import { render } from "./cart-table.vue?vue&type=template&id=9f6a8e52&scoped=true&ts=true"
import script from "./cart-table.vue?vue&type=script&lang=ts"
export * from "./cart-table.vue?vue&type=script&lang=ts"

import "./cart-table.vue?vue&type=style&index=0&id=9f6a8e52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f6a8e52"]])

export default __exports__